import { NavigationExtras } from '@angular/router';
import { SearchResult } from '../services/search.service';

export interface ResolvedSearchRoute {
    commands: (string | number)[];
    extras?: NavigationExtras;
}

/**
 * Resuelve a qué ruta navegar al seleccionar un resultado del buscador global.
 * Extraído de topnavbar.component.ts (itemSelected) para reutilizarlo en el
 * command palette. Mismo comportamiento: los cargos (`position`) no tienen
 * pantalla propia, se navega al grupo/institución al que pertenecen.
 */
export function resolveSearchResultRoute(item: SearchResult): ResolvedSearchRoute | null {
    const entity = item.entity;
    const id = item.related_entity_id > 0 ? item.related_entity_id : item.id;

    if (entity === 'person' || item.related_entity === 'person') {
        return { commands: ['/persons/edit', id], extras: { queryParams: { person_type: 'authority' } } };
    }
    if (entity === 'group' || item.related_entity === 'group') {
        return { commands: ['/groups/edit', id] };
    }
    if (entity === 'event') {
        return { commands: ['/events/edit', id, 'false'] };
    }
    if (entity === 'correspondence') {
        return { commands: ['/correspondence/edit', id] };
    }
    if (entity === 'gift') {
        return { commands: ['/gifts/edit', id] };
    }
    if (entity === 'restaurant') {
        return { commands: ['/restaurants/edit', id] };
    }
    if (entity === 'material') {
        return { commands: ['/materials/edit', id] };
    }
    if (entity === 'space') {
        return { commands: ['/spaces/list'] };
    }

    return null;
}
